import React from 'react';
import { motion } from 'framer-motion';
import FloatingParticles from '../../components/particles/FloatingParticles';
import {toAbsoluteUrl} from '../../../_metronic/helpers'

export default function IexpHome() {
  return (
    <div className="flex items-center justify-center relative overflow-hidden" style={{ height: 'calc(100vh - 131px)' }}>
      <FloatingParticles />
      
      {/* Main content */}
      <div className="relative z-10 flex flex-col items-center justify-center px-6 text-center">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="mb-12"
        >
          <img
            src={toAbsoluteUrl('/media/logos/logo-data-analytics.png')}
            alt="Insight Experience"
            className="h-20 md:h-28 w-auto drop-shadow-2xl"
          />
        </motion.div>

        {/* Welcome message */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
          className="space-y-6"
        >
          <h1 className="text-4xl md:text-6xl font-bold text-slate-800 tracking-tight">
            Bem-vindo ao{' '}
            <span className="bg-gradient-to-r from-[#E63946] to-[#00B4D8] bg-clip-text text-transparent">
              Insight Experience
            </span>
          </h1>
          
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="text-slate-600 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed"
          >
            Sua jornada para insights transformadores começa aqui.
            Prepare-se para uma experiência única e inovadora.
          </motion.p>
        </motion.div>

        {/* Animated line */}
        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1, delay: 0.9, ease: 'easeOut' }}
          className="mt-12 h-[2px] w-48 bg-gradient-to-r from-transparent via-[#E63946] to-transparent"
        />

        {/* Rocket animation */}
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 1.2 }}
          className="mt-8"
        >
          <motion.div
            animate={{ y: [0, -10, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
            className="text-4xl"
          >
            🚀
          </motion.div>
        </motion.div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#e9edf1] to-transparent pointer-events-none" />
    </div>
  );
}